import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'account-edit',
		prop1: '',
		prop2: '',
		prop3: [],

		userData: [],
		userDataComp: '0',

		profileData: [],
		profileDataComp: '0',

		inviteArray: [],
		inviteComp: '0',



	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2},

		setUserData(state, payload) { state.userData = payload.info; state.userDataComp = payload.info1; },
		setUserDataComp(state, payload) { state.userDataComp = payload.info1; },

		setProfileData(state, payload) { state.profileData = payload.info; state.profileDataComp = payload.info1; },
		setProfileDataComp(state, payload) { state.profileDataComp = payload.info1; },

		setInvites(state, payload) { state.inviteArray = payload.info; state.inviteComp = payload.info1; },
		setInviteComp(state, payload) { state.inviteComp = payload.info1; },
		
  	},

	actions: {
		getUserInformation(context, payload) {
			context.commit("setUserDataComp", { info1: '0' }) 
			axios.get('/utility/user/user/getuserdetails')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUserData", { info: b, info1: '1' }) 
	          	});
		},
		getProfileInformation(context, payload) {
			context.commit("setProfileDataComp", { info1: '0' }) 
			axios.get('/utility/user/profile/getprofiledetails')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setProfileData", { info: b, info1: '1' }) 
	          	});
		},
		

		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2 })  },
		getAllInvites(context, payload) {
			context.commit("setInviteComp", { info1: '0' }) 
			axios.get('/admin/utility/getallinvites')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setInvites", { info: b, info1: '1' }) 
	          	});
		},
		
		
		
		
	}

})